import { useQuery, useQueryClient, } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { API_INBOX_FAVORITES_PATH } from 'src/services/api/inboxes/constants';
import {type IInboxFavorite} from 'src/services/api/inboxes/types';

type IInboxFavoriteResponse = {
    favorites: IInboxFavorite[]
}

export const useInboxFavorites = () => {
    const queryClient = useQueryClient();

    return useQuery([queryKeys.inboxFavorites], async () => {
        const res = await apiClient(API_INBOX_FAVORITES_PATH).json<IInboxFavoriteResponse>();

        return res.favorites;
    }, {
        keepPreviousData: true,
        onSuccess: (favorites) => {
            for (const favorite of favorites) {
                queryClient.setQueryData([queryKeys.inboxFavorites, favorite.id], favorite);
            }
        }
    });
};
